/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {FlagOutlined, LinkOutlined, MessageOutlined, PhoneAndroidOutlined, TitleOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ESTADOANUNCIOS} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoFecha from "../../Modulo_formularios/Componentes/IngresoFecha";


const Formulario_Sostenibilidad = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} dato={'estado'} {...props}
                                   opciones={ESTADOANUNCIOS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoFecha  nombre={'Fecha'}
                                  dato={'fecha'} {...props}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Imagen del servicio dimencion 2x3 (peso menor a 300Kb)</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagenCrop alto={2} ancho={3}
                                       dato={'img'} {...props}

                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Nombre del post'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Descripcion del post'}
                                  dato={'descripcion'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Mas Detalles del Post</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo parrafo extenso'}
                                  dato={'tituloDos'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={8} nombre={'Parrafo Extenso'}
                                  dato={'descripcionDos'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Mas Detalles del Post Dos</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo parrafo extenso'}
                                  dato={'tituloTres'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={8} nombre={'Parrafo Extenso'}
                                  dato={'descripcionTres'} {...props}

                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Sostenibilidad